import styled from 'styled-components'

export const StyledFileNameInput = styled.input`
    display: inline-block;
    border: none;
    border-bottom: 1px solid lightgrey;
    width: 80%;
    padding: 0;
    font-size: 13px;
    &:focus { outline: none }
`;